<template>
  <div id="ExhibitionPc">
    <div class="main_bg">
      <!-- KV -->
      <div class="banner"></div>

      <div class="main2-content">
        <div class="layout-flex-title">
          <div class="title-btn active" @click="handleBtnChange('store')">
            ID.STORE
          </div>
          <div class="title-btn" @click="handleBtnChange('storep')">
            ID.3潮趣展
          </div>
        </div>
      </div>

      <!-- 列表车型 -->
      <div class="main2-content" style="padding-top: 11rem">
        <div
          class="layout-flex"
          v-for="(item, index) in workspace5"
          :key="index"
          :style="{ flexDirection: index % 2 ? 'row-reverse' : 'row' }"
        >
          <div
            class="layout-flex-1"
            :style="{ padding: index % 2 ? '0 0 0 11rem' : '0 11rem 0 0' }"
          >
            <div class="detail-icon">
              <img class="image" :src="item.iconurl" />
            </div>
            <div class="detail-title">{{ item.title }}</div>
            <div class="detail-content">{{ item.content }}</div>
            <div class="detail-btn" v-if="item.url" @click="handleDetail(item.url)"></div>
          </div>
          <div class="layout-flex-2">
            <el-carousel
              indicator-position="none"
              arrow="always"
              :autoplay="false"
              style="width: 100%"
              height="47rem"
              :initial-index="dialogIndex"
            >
              <el-carousel-item
                v-for="(item2, index2) in item.imgurl"
                :key="'z' + index2"
              >
                <div @click="handleVideo(index, index2)">
                  <img :src="item2" style="width: 100%" />
                  <img class="videoPlay" src="./components/play.png" />
                </div>
              </el-carousel-item>
              <el-carousel-item
                v-for="(item2, index2) in item.imgurl2"
                :key="index2"
              >
                <img
                  @click="handleImg2(index, index2)"
                  :src="item2"
                  style="width: 100%"
                />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div>
          <img class="image" src="https://www.csvw.com/u/cms/www/202110/15203508l3nw.png"/>
        </div>
      </div>

      <!-- 现场花絮 -->
      <div
        class="main2-content"
        style="padding-top: 11rem; padding-bottom: 11rem"
      >
        <div class="title">
          <div class="titlebg"></div>
          <div class="t1">探秘ID.Store</div>
        </div>
        <div>
          <div class="layout-image" :key="index6">
            <div
              v-for="(item, index) in workspace6Item"
              :key="index"
              style="display: inline-block; word-spacing: normal"
            >
              <div class="layout-image-left">
                <div class="layout-image-1">
                  <img
                    class="image"
                    :src="item[0]"
                    @click="handleImg(index * 5 + 0)"
                  />
                </div>
              </div>

              <div
                class="layout-image-right"
                :style="{
                  margin: index + 1 == workspace6Item.length ? '0' : '',
                }"
              >
                <div class="layout-image-2">
                  <img
                    class="image"
                    :src="item[1]"
                    @click="handleImg(index * 5 + 1)"
                  />
                </div>
                <div class="layout-image-3">
                  <img
                    class="image"
                    :src="item[2]"
                    @click="handleImg(index * 5 + 2)"
                  />
                </div>
                <div class="layout-image-4">
                  <img
                    class="image"
                    :src="item[3]"
                    @click="handleImg(index * 5 + 3)"
                  />
                </div>
                <div class="layout-image-5">
                  <img
                    class="image"
                    :src="item[4]"
                    @click="handleImg(index * 5 + 4)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹框图片 -->
    <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible">
      <el-carousel
        indicator-position="none"
        arrow="always"
        :autoplay="false"
        style="width: 100%"
        height="82rem"
        :initial-index="dialogIndex"
      >
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <img :src="item" style="width: 100%" />
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <!-- 弹框视频播放 -->
    <el-dialog :visible.sync="dialogVisible2" v-if="dialogVisible2">
      <contentVideo2 :url="dialogVideo"></contentVideo2>
    </el-dialog>
  </div>
</template>

<script>
import contentVideo from "./components/contentVideo.vue";
import contentVideo2 from "./components/contentVideo2.vue";
import config from "./config";
export default {
  components: {
    contentVideo,
    contentVideo2,
  },
  data() {
    return {
      ...config,
      index6: "workspace60",
      list: [],
      // 图片
      dialogVisible: false,
      // 视频
      dialogVisible2: false,
      dialogIndex: 0,
      dialogImg: "",
      dialogVideo: "",
    };
  },
  computed: {
    workspace6Item() {
      return this[`${this.index6}`];
    },
  },
  mounted() {
    document.documentElement.style.fontSize =
      document.documentElement.clientWidth / 192 + "px";
  },
  destroyed() {
    document.documentElement.style.fontSize = "62.5%";
  },
  methods: {
    // 详情
    handleDetail(url) {
      window.open(url, "_blank");
    },
    // 列表-图片
    handleImg2(index, index2) {
      this.dialogVisible = true;
      this.list = this.workspace5[index]["imgurlMobile2"];
      this.dialogIndex = index2;
    },
    // 列表-视频
    handleVideo(index, index2) {
      this.dialogVisible2 = true;
      this.dialogVideo = this.workspace5[index]["videourl"][index2];
    },
    // 花絮-图片
    handleImg(index) {
      this.dialogVisible = true;
      this.list = this.workspace60big;
      this.dialogIndex = index;
    },
    // 切换车子
    handleBtnChange(key) {
      this.$emit("changeTab", key);
    },
  },
};
</script>

<style lang="less" scoped>
@import "./pc.less";
</style>
